import { Context, Middleware } from '@nuxt/types'
import { isString } from '~/shared/utils/guards'

/**
 * Попытка авторизации пользователя
 */
const authorize: Middleware = async ({ route, $services, $tstore, $axios }: Context) => {
  if (isString(route.query.token) && route.query.token) {
    $services.user.setCookieToken(route.query.token)
  }
  if (isString(route.query.refresh_token) && route.query.refresh_token) {
    $services.user.setCookieRefreshToken(route.query.refresh_token)
  }
  if (isString(route.query.update_refresh_token) && route.query.update_refresh_token) {
    $services.user.updateRefreshToken(route.query.update_refresh_token)
  }

  const token = $services.user.getCookieToken()
  const tokenChanged = !!route.query.token
  const canRefresh = !!$services.user.getRefreshCookieToken()

  if (token) {
    $axios.defaults.headers.common['Authorization-SF-Token'] = token
  }

  const needAuth = !$tstore.auth.isLogged && (token || canRefresh)

  if (!needAuth && !tokenChanged) {
    return
  }

  try {
    let user = token ? await $services.user.getAuthorizedUser({ throwOnTransientError: true }) : null

    if (user === null && canRefresh) {
      const tokens = await $services.user.getAccessTokenByRefresh()

      if (tokens) {
        $services.user.setCookieToken(tokens.accessToken)
        $services.user.setCookieRefreshToken(tokens.refreshToken)
        $axios.defaults.headers.common['Authorization-SF-Token'] = tokens.accessToken
        user = await $services.user.getAuthorizedUser({ throwOnTransientError: true })
      }
    }

    if (user !== null) {
      $tstore.auth.setUser(user)
    } else {
      $services.user.removeToken()
      delete $axios.defaults.headers.common['Authorization-SF-Token']
    }
  } catch (error) {
    $services.loggerFactory('authorize').error('Не удалось проверить сессию', error)
  }
}

export default authorize
